import 'prometheus.aaa.scss';
import 'prometheus.modern.scss';

import './theme.aaa.scss';
import './theme.modern.scss';

import { registerDocumentClickBubblingOnTop } from "@itslearning/atlas/frames/IframeClickEventHelper";
import { postMessage } from "@itslearning/atlas/network/postMessage";

import App from './lib/App/App.svelte';

import i18n from "@its-ui/planner-common/i18n.js";
import config from "@its-ui/planner-common/config.js";
import { ItslearningPageTitle } from "@its-ui/planner-common/constants.js";
import { mount } from 'svelte';
import { loadLangs } from './lang/loader';

await loadLangs(config.lang);

// Ensure the top frame is informed of clicks, this is important to for instance close dropdowns.
registerDocumentClickBubblingOnTop();

// @ts-ignore
const topPage = window.itslTop || window.top;

// If plans is opened in an itslearning iFrame set the selected menu item and collapse the tree menu
if (topPage) {
    if (typeof topPage.hideContentAreaTreeMenu === "function") {
        topPage.hideContentAreaTreeMenu();
    }

    if (typeof topPage.SelectCurrentNavigationItem === "function") {
        topPage.SelectCurrentNavigationItem("planner");
    }
}

postMessage({
    messageName: "askIfCustomTreeLinkNavigationRequired"
});

document.title = i18n.title + ItslearningPageTitle;

const app = mount(App, {
    target: document.getElementById("plans"),
    // @ts-ignore
    props: { selectedTab: config.tab }
});

export default app;
